const AUTH_RESOURCE_TYPE = 'cbd_ocr_extraction';
const CLIENT_ID = 'cbd-app-ocr';
const API_ENDPOINTS = {
    token: 'api/v1/oauth2/token',
    extractDocument: 'extract-document/'
};
// Default timeout for API requests in milliseconds
const DEFAULT_REQUEST_TIMEOUT = 30000;
var ErrorCodes;
(function(ErrorCodes) {
    // HTTP status codes
    ErrorCodes[ErrorCodes["BAD_REQUEST"] = 400] = "BAD_REQUEST";
    ErrorCodes[ErrorCodes["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    ErrorCodes[ErrorCodes["FORBIDDEN"] = 403] = "FORBIDDEN";
    ErrorCodes[ErrorCodes["NOT_FOUND"] = 404] = "NOT_FOUND";
    ErrorCodes[ErrorCodes["TIMEOUT"] = 408] = "TIMEOUT";
    ErrorCodes[ErrorCodes["REQUEST_TIMEOUT"] = 408] = "REQUEST_TIMEOUT";
    ErrorCodes[ErrorCodes["CONFLICT"] = 409] = "CONFLICT";
    ErrorCodes[ErrorCodes["UNPROCESSABLE"] = 422] = "UNPROCESSABLE";
    ErrorCodes[ErrorCodes["SERVER_ERROR"] = 500] = "SERVER_ERROR";
    // Custom error codes
    ErrorCodes[ErrorCodes["AUTHENTICATION_FAILED"] = 1000] = "AUTHENTICATION_FAILED";
    ErrorCodes[ErrorCodes["TOKEN_MISSING"] = 1001] = "TOKEN_MISSING";
    ErrorCodes[ErrorCodes["TOKEN_EXPIRED"] = 1002] = "TOKEN_EXPIRED";
    ErrorCodes[ErrorCodes["EXTRACTION_FAILED"] = 2000] = "EXTRACTION_FAILED";
    ErrorCodes[ErrorCodes["INVALID_FILE"] = 2001] = "INVALID_FILE";
    ErrorCodes[ErrorCodes["FILE_TOO_LARGE"] = 2002] = "FILE_TOO_LARGE";
    ErrorCodes[ErrorCodes["UNSUPPORTED_FORMAT"] = 2003] = "UNSUPPORTED_FORMAT";
    ErrorCodes[ErrorCodes["OCR_TIMEOUT"] = 2004] = "OCR_TIMEOUT";
    ErrorCodes[ErrorCodes["REQUEST_ABORTED"] = 2005] = "REQUEST_ABORTED";
    ErrorCodes[ErrorCodes["NETWORK_ERROR"] = 3000] = "NETWORK_ERROR";
    ErrorCodes[ErrorCodes["UNKNOWN_ERROR"] = 9999] = "UNKNOWN_ERROR";
})(ErrorCodes || (ErrorCodes = {}));
var AuthErrorCode;
(function(AuthErrorCode) {
    AuthErrorCode["AUTH_FAILED"] = "AUTH_FAILED";
    AuthErrorCode["AUTH_ERROR_401"] = "AUTH_ERROR_401";
    AuthErrorCode["AUTH_ERROR_403"] = "AUTH_ERROR_403";
    AuthErrorCode["AUTH_ERROR_500"] = "AUTH_ERROR_500";
})(AuthErrorCode || (AuthErrorCode = {}));
var ProcessingErrorCode;
(function(ProcessingErrorCode) {
    ProcessingErrorCode["OCR_PROCESSING_FAILED"] = "OCR_PROCESSING_FAILED";
    ProcessingErrorCode["OCR_ERROR_400"] = "OCR_ERROR_400";
    ProcessingErrorCode["OCR_ERROR_401"] = "OCR_ERROR_401";
    ProcessingErrorCode["OCR_ERROR_403"] = "OCR_ERROR_403";
    ProcessingErrorCode["OCR_ERROR_404"] = "OCR_ERROR_404";
    ProcessingErrorCode["OCR_ERROR_422"] = "OCR_ERROR_422";
    ProcessingErrorCode["OCR_ERROR_500"] = "OCR_ERROR_500";
    ProcessingErrorCode["OCR_REQUEST_ABORTED"] = "OCR_REQUEST_ABORTED";
    ProcessingErrorCode["OCR_REQUEST_TIMEOUT"] = "OCR_REQUEST_TIMEOUT";
    ProcessingErrorCode["INVALID_FILE_FORMAT"] = "INVALID_FILE_FORMAT";
    ProcessingErrorCode["UNSUPPORTED_FORMAT"] = "UNSUPPORTED_FORMAT";
    ProcessingErrorCode["FILE_SIZE_EXCEEDED"] = "FILE_SIZE_EXCEEDED";
})(ProcessingErrorCode || (ProcessingErrorCode = {}));
const MAX_FILE_SIZE = 5 * 1024 * 1024;
const ALLOWED_FILE_TYPES = [
    'application/pdf',
    'image/png',
    'image/jpg',
    'image/jpeg',
    'image/tiff'
];

export { ALLOWED_FILE_TYPES, API_ENDPOINTS, AUTH_RESOURCE_TYPE, AuthErrorCode, CLIENT_ID, DEFAULT_REQUEST_TIMEOUT, ErrorCodes, MAX_FILE_SIZE, ProcessingErrorCode };
